const num = new Intl.NumberFormat('en-US');

/* Money is formatted by each app from minor units in the payment's own currency (e.g. Payments' format.ts), never here. */
/** 9,842 */
export const count = (n: number) => num.format(n);
/** 94.6% */
export const pct = (n: number, digits = 1) => `${n.toFixed(digits)}%`;

/** Mix a CSS colour (usually a var) with transparency for tints. */
export const tint = (color: string, percent: number) => `color-mix(in srgb, ${color} ${percent}%, transparent)`;

export const v = (token: string) => `var(--ix-${token})`;

/** Sentence-case label for an UPPER_SNAKE code ("SCOPE_ROLE" → "Scope role"). */
export const humanize = (code: string) => {
  const s = code.replace(/_/g, ' ').toLowerCase();
  return s.charAt(0).toUpperCase() + s.slice(1);
};
